module.exports = __webpack_public_path__ + "img/convergists5.8b5b822e.png";